import { createSlice } from '@reduxjs/toolkit';

const initialState: IInventoryState = {
  data: [],
  selected: [],
  requested: false,
  filters: {
    models: {},
    makes: {}
  },
  filtersRequested: false,
  filtersSelected: {},
  featuredFilters: {
    expiring: null,
    featured: null,
    noVin: null,
    noPrice: null,
    noPictures: null
  },
  uploadImageProgress: null,
};

export const inventorySlice = createSlice({
  name: 'inventory',
  initialState,
  reducers: {
    setSelectedFilters(state, {payload}) {
      return { ...state, filtersSelected: payload }
    },
    setInventory(state, {payload}) {
      return { ...state, data: payload?.data, meta: payload?.meta };
    },
    setFilters(state, {payload}) {
      return { ...state, filters: payload?.data}
    },
    setSearchParams(state, {payload}) {
      return { ...state, searchParams: payload}
    },
    setFeaturedFilters(state, {payload}) {
      return { ...state, featuredFilters: payload}
    },
    setUploadImageProgress(state, { payload }) {
      return { ...state, uploadImageProgress: payload };
    }
  }
});

export const {
  setSelectedFilters,
  setInventory,
  setFilters,
  setSearchParams,
  setFeaturedFilters,
  setUploadImageProgress
} = inventorySlice.actions

export const getInventory = (state: IReducerStates) => state.inventory;
